import { Segment } from '@dna/analytics'

class DNAAccordion extends HTMLElement {
  connectedCallback() {
    this.addEventListener('sl-show', this._trackAccordionOpened)
  }

  _trackAccordionOpened() {
    // @segment
    Segment.protect(() => {
      let $accordionHeading = this.renderRoot?.querySelector('summary')
      if (this.querySelector('.js-accordion-summary'))
        $accordionHeading = this.querySelector('.js-accordion-summary')

      const accordionHeadingText = $accordionHeading?.textContent.trim()

      Segment.track(Segment.CONSTANTS.EVENTS.ACCORDION_OPENED, {
        accordion_heading: accordionHeadingText,
      })
    })
  }
}

customElements.define('dna-accordion', DNAAccordion)
